import React, { useRef } from 'react';
const reviews = [{
  text: 'Por $15 no esperaba tanto. Los bonos de la casa y el ITIN solos valen 10 veces más.',
  name: 'Roberto V.',
  role: 'Instalador · Phoenix, AZ'
}, {
  text: 'En la primera semana cancelé $71 al mes en suscripciones que ni sabía que tenía. Este sistema funciona.',
  name: 'Diego R.',
  role: 'Warehouse · Dallas, TX'
}, {
  text: "No me dice 'gasta menos en café.' Me dice exactamente qué pagar primero cuando no alcanza.",
  name: 'Ramón V.',
  role: 'Técnico HVAC · Miami, FL'
}, {
  text: 'Usé el Script #2 con mi landlord y me dio 2 semanas más sin problema. Nunca había podido tener esa conversación.',
  name: 'José M.',
  role: 'Delivery · Chicago, IL'
}, {
  text: 'Mi esposa y yo llevábamos meses sin hablar de dinero porque terminaba en pelea. El capítulo 9 nos cambió todo.',
  name: 'Javier A.',
  role: 'Construcción · Phoenix, AZ'
}];
export function SocialProof() {
  const scrollRef = useRef<HTMLDivElement>(null);
  return <section id="social-proof" className="py-12 px-5 bg-brand-bg scroll-mt-16" data-id="element-403">
      <div className="max-w-[1100px] mx-auto" data-id="element-404">
        <h2 className="text-2xl font-black text-brand-navy mb-8 text-center font-montserrat" data-id="element-405">
          Lo Que Dicen los Trabajadores
        </h2>

        {/* Horizontal scroll carousel */}
        <div ref={scrollRef} className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 scrollbar-hide -mx-5 px-5" style={{
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-406">
          {reviews.map((review, i) => <div key={i} className="snap-start shrink-0 w-[280px] sm:w-[320px] bg-white border border-brand-border rounded-xl p-5 shadow-sm" data-id="element-407">
              <div className="text-brand-statusYellow text-sm mb-3" data-id="element-408">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-sm text-brand-textPrimary leading-relaxed font-medium mb-4 italic" data-id="element-409">
                "{review.text}"
              </p>
              <div className="text-xs font-bold text-brand-navy uppercase tracking-wide" data-id="element-410">
                — {review.name}{' '}
                <span className="text-brand-textSecondary font-normal" data-id="element-411">
                  · {review.role}
                </span>
              </div>
            </div>)}
        </div>

        {/* Scroll hint for mobile */}
        <p className="text-center text-xs text-brand-textSecondary mt-3 md:hidden" data-id="element-412">
          ← Desliza para ver más →
        </p>
      </div>
    </section>;
}